<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M1,0L11,0L16,5L16,15C16,15.55,15.55,16,15,16L1,16C0.45,16,0,15.55,0,15L0,1C0,0.45,0.45,0,1,0ZM2,14L14,14L14,6L10,6L10,2L2,2L2,14ZM5.01172,10.64L6.5319,10.64Q6.5319,11.0013,6.66211,11.252Q6.79232,11.4993,7.00716,11.6556Q7.22201,11.8086,7.51172,11.8835Q7.80143,11.9583,8.11068,11.9583Q8.32227,11.9583,8.5599,11.9258Q8.80078,11.89,9.00912,11.7891Q9.2207,11.6882,9.36068,11.5156Q9.50065,11.3398,9.50065,11.0697Q9.50065,10.7799,9.3151,10.6009Q9.12956,10.4219,8.83008,10.3014Q8.5306,10.181,8.14974,10.0931Q7.76888,10.002,7.38151,9.89128Q6.98112,9.79037,6.60026,9.64714Q6.2194,9.50065,5.91992,9.27279Q5.62044,9.04167,5.4349,8.69987Q5.24935,8.35482,5.24935,7.86328Q5.24935,7.31641,5.48372,6.91276Q5.7181,6.50586,6.09896,6.23893Q6.47982,5.96875,6.95833,5.83854Q7.4401,5.70833,7.91862,5.70833Q8.47852,5.70833,8.99284,5.83854Q9.51042,5.9655,9.91081,6.25195Q10.3112,6.53841,10.5456,6.97786Q10.7799,7.41732,10.7799,8.03906L9.25977,8.03906Q9.24023,7.72005,9.12305,7.51172Q9.00912,7.30013,8.81706,7.17969Q8.62826,7.05925,8.38412,7.01042Q8.13997,6.95833,7.85026,6.95833Q7.6582,6.95833,7.4694,7.00065Q7.2806,7.03971,7.12435,7.14062Q6.9681,7.23828,6.86719,7.38802Q6.76953,7.53776,6.76953,7.76888Q6.76953,7.97721,6.84766,8.10742Q6.92904,8.23763,7.16341,8.34831Q7.40104,8.45898,7.81445,8.56966Q8.23112,8.67708,8.90169,8.84961Q9.10026,8.88867,9.45508,8.99284Q9.8099,9.09701,10.1582,9.32812Q10.5098,9.55925,10.7637,9.94336Q11.0208,10.3275,11.0208,10.9297Q11.0208,11.418,10.8288,11.8379Q10.64,12.2578,10.2656,12.5638Q9.89128,12.8698,9.33463,13.0391Q8.78125,13.2083,8.05208,13.2083Q7.46289,13.2083,6.90625,13.0586Q6.35286,12.9089,5.92643,12.5898Q5.50326,12.2676,5.2526,11.7858Q5.00195,11.3008,5.01172,10.64Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'LayoutSql',
} as DefineComponent
</script>
